<form class="form-horizontal" role="form" name="frmRaster">
  <div class="form-group m-3">
    <hs-file-upload (uploaded)="handleFileUpload($event)" [uploader]="'hs-file-raster' + app"
      [acceptedFormats]="acceptedFormats">
    </hs-file-upload>
  </div>
  <div *ngIf="hsAddDataCommonService.showDetails">
    <div class="d-flex flex-row justify-content-around">
      <div class="d-flex flex-column justify-content-center">
        <p class="p-2 bg-success rounded" style="color: white;"> {{data.files.length}}
          {{'ADDLAYERS.filesSelected' | translateHs }}</p>
      </div>
      <div class="d-flex flex-column mw-75">
        <p *ngFor="let file of data.files">{{file.name}}</p>
      </div>
    </div>
    <hs-file-raster-timeseries *ngIf="fileType === 'raster-ts'" [data]="data"> </hs-file-raster-timeseries>
    <hs-new-layer-form [data]="data"></hs-new-layer-form>
    <hs-add-layer-authorized [data]="data"></hs-add-layer-authorized>
  </div>
</form>